<template>
    <div class="container">
        <div @click="goback" style="font-size:14px;margin-bottom:10px;cursor: pointer;width:50px">
            <i class="el-icon-back"></i>
            返回
        </div>
        <el-form ref="formRef" :model="form" label-width="auto" style="margin: auto;max-width: 80%;" size="small"
            :rules="rules">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="商户CODE" prop="code">
                        <el-input v-model="form.code" />
                    </el-form-item>
                    <el-form-item label="企业名称" prop="partner_name">
                        <el-input v-model="form.partner_name" />
                    </el-form-item>
                    <el-form-item label="联系人姓名" prop="contact_name">
                        <el-input v-model="form.contact_name" />
                    </el-form-item>
                    <el-form-item label="联系人电话" prop="mobile">
                        <el-input v-model="form.mobile" />
                    </el-form-item>
                    <el-form-item label="联系人邮箱" prop="email">
                        <el-input v-model="form.email" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item>
                <el-button type="primary" size="small" @click="onSubmit(formRef)">确定</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { reactive, onMounted, ref, toRaw } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../../axios/api'

export default {
    setup() {
        const router = useRouter()
        const route = useRoute()
        const form = reactive({
            code: '',
            partner_name: '',
            contact_name: '',
            mobile: '',
            email: ''
        })
        const formRef = ref()
        const rules = reactive({
            code: [
                { required: true, message: '请输入商户CODE', trigger: 'blur' },
            ],
            partner_name: [
                { required: true, message: '请输入企业名称', trigger: 'blur' },
            ],
            contact_name: [
                { required: true, message: '请输入联系人姓名', trigger: 'blur' },
            ],
            mobile: [
                { required: true, message: '请输入联系人电话', trigger: 'blur' },
            ]
        })
        const isEdit = ref(false)

        console.log('route -->', route)


        const onSubmit = async (formEl) => {
            if (!formEl) return
            await formEl.validate(async (valid, fields) => {
                if (valid) {
                    const apiMethod = isEdit.value ? api.SalesPartnerUpdate : api.SalesPartnerCreate
                    const res = await apiMethod(toRaw(form))
                    if (res.data.code === 200) {
                        ElMessage.success(`${isEdit.value ? '更新' : '添加'}成功`)
                        router.push('/salespartner/list')
                    } else {
                        ElMessage.error('添加失败: ' + res.data.msg)
                    }
                } else {
                    console.log('error submit!', fields)
                }
            })
        }

        const goback = () => {
            router.go(-1)
        }

        onMounted(() => {
            const code = route.params.code
            if (code && code !== '0') {
                isEdit.value = true
                api.SalesPartnerDetail({ code }).then(res => {
                    if (res.data.code === 200) {
                        Object.assign(form, res.data.data)
                    } else {
                        ElMessage.error('获取详情失败: ' + res.data.msg)
                    }
                }).catch(err => {
                    console.error('获取详情失败:', err)
                    ElMessage.error('获取详情失败')
                })
            }
        })

        return {
            form,
            onSubmit,
            goback,
            rules,
            formRef,
            isEdit
        }
    }
}
</script>